export default {
  total: "Gesamt",
  paid: "Bezahlt",
  unpaid: "Unbezahlt",
  editor: "Bearbeiter",
  viewer: "Gast",
  view: "Anzeigen",
  save: "Speichern",
  cancel: "Abbrechen",
  delete: "Löschen",
  edit: "Bearbeiten",
  add: "Hinzufügen",
  close: "Schließen",
  confirm: "Bestätigen",
  yes: "Ja",
  no: "Nein",
  loading: "Laden...",
  error: "Fehler",
  success: "Erfolg",
  warning: "Warnung",
  info: "Information",
  search: "Suchen",
  filter: "Filtern",
  sort: "Sortieren",
  export: "Exportieren",
  import: "Importieren",
  download: "Herunterladen",
  upload: "Hochladen",
  print: "Drucken",
  share: "Teilen",
  copy: "Kopieren",
  paste: "Einfügen",
  cut: "Ausschneiden",
  undo: "Rückgängig",
  redo: "Wiederholen",
  refresh: "Aktualisieren",
  back: "Zurück",
  next: "Weiter",
  previous: "Vorherige",
  first: "Erste",
  last: "Letzte",
  all: "Alle",
  none: "Keine",
  select: "Auswählen",
  deselect: "Abwählen",
  clear: "Löschen",
  reset: "Zurücksetzen",
  apply: "Anwenden",
  submit: "Senden",
  send: "Senden",
  receive: "Empfangen",
  create: "Erstellen",
  update: "Aktualisieren",
  remove: "Entfernen",
  duplicate: "Duplizieren",
  move: "Verschieben",
  more: "Mehr",
  less: "Weniger",
  show: "Anzeigen",
  hide: "Ausblenden",
  details: "Details",
  actions: {
    _self: "Aktionen",
    add: "Hinzufügen",
    addLong: "Neues Element hinzufügen",
    importGuests: "Gäste importieren",
    share: "Teilen",
    useExample: "Beispiel verwenden",
    addEvent: "Ereignis hinzufügen",
    addExamples: "Beispiele hinzufügen",
    addingExamples: "Beispiele werden hinzugefügt...",
    edit: "Bearbeiten",
    delete: "Löschen",
    cancel: "Abbrechen",
    save: "Speichern"
  },
  noResults: "Keine Ergebnisse gefunden",
  pagination: {
    showing: "Zeige {{from}} bis {{to}} von {{total}} Einträgen"
  },
  time: "Zeit",
  title: "Titel",
  category: "Kategorie",
  description: "Beschreibung",
  continue: "Fortfahren",
  required: "Erforderlich",
  optional: "Optional",
  or: "oder",
  and: "und",
  selectAll: "Alle auswählen",
  deselectAll: "Alle abwählen",
  disconnect: "Trennen",
  sending: "Senden...",
  verified: "Verifiziert",
  importGuests: "Gäste importieren",
  status: {
    to_contact: "Zu Kontaktieren",
    contacted: "Kontaktiert",
    meeting_scheduled: "Termin Vereinbart",
    quote_received: "Angebot Erhalten",
    hired: "Engagiert",
    deposit_paid: "Anzahlung Geleistet",
    completed: "Abgeschlossen",
    cancelled: "Storniert",
    pending: "Ausstehend",
    confirmed: "Bestätigt",
    declined: "Abgelehnt",
    accepted: "Akzeptiert",
    inProgress: "In Bearbeitung",
    paid: "Bezahlt",
    unpaid: "Unbezahlt",
    overdue: "Überfällig",
    scheduled: "Geplant",
    done: "Erledigt",
    todo: "Zu erledigen",
    researching: "Recherche"
  },
  categories: {
    other: "Sonstiges",
    venue: "Location",
    catering: "Catering",
    photography: "Fotografie",
    music: "Musik",
    decoration: "Dekoration",
    flowers: "Blumen",
    attire: "Kleidung",
    jewelry: "Schmuck",
    transport: "Transport",
    lodging: "Unterkunft",
    ceremony: "Zeremonie",
    reception: "Empfang",
    videography: "Videografie",
    florist: "Florist",
    cake: "Torte",
    dress: "Kleid",
    suit: "Anzug",
    hair_makeup: "Haare & Make-up",
    beauty: "Schönheit"
  },
  pwa: {
    offlineReady: "App bereit für Offline-Nutzung",
    newContent: "Neuer Inhalt verfügbar, zum Aktualisieren klicken.",
    reload: "Neu laden"
  },
  validation: {
    required: {
      firstName: "Vorname ist erforderlich",
      lastName: "Nachname ist erforderlich",
      email: "E-Mail ist erforderlich"
    },
    invalid: {
      email: "E-Mail ist ungültig"
    }
  },
  empty: {
    title: "Keine Daten",
    description: "Nichts anzuzeigen."
  },
  errors: {
    submit: "Fehler beim Senden",
    loadGuests: "Fehler beim Laden der Gäste",
    updateGuest: "Fehler beim Aktualisieren des Gastes",
    socialLoginFailed: "Social Login fehlgeschlagen",
    userOrWeddingNotFound: "Benutzer oder Hochzeit nicht gefunden",
    googleSignIn: "Google Login Fehler",
    loadVendors: "Fehler beim Laden der Dienstleister",
    addVendor: "Fehler beim Hinzufügen des Dienstleisters",
    updateVendor: "Fehler beim Aktualisieren des Dienstleisters",
    deleteVendor: "Fehler beim Löschen des Dienstleisters",
    saveSeatingPlan: "Fehler beim Speichern des Sitzplans",
    generateSeatingPlan: "Fehler beim Generieren des Sitzplans"
  },
  columns: {
    name: "Name",
    status: "Status",
    category: "Kategorie",
    actions: "Aktionen",
    plusOne: "+1",
    children: "Kinder"
  },
  confirmDialog: {
    delete: "Möchten Sie dieses Element wirklich löschen?",
    budgetRemoval: {
      title: "Budget löschen",
      message: "Möchten Sie dieses Budget wirklich löschen?",
      confirm: "Löschen",
      cancel: "Abbrechen"
    }
  },
  deleteConfirmation: {
    title: "Löschen",
    description: "Diese Aktion kann nicht rückgängig gemacht werden.",
    confirmTitle: "Löschen bestätigen",
    confirmDescription: "Möchten Sie dieses Element wirklich löschen?",
    confirmButton: "Löschen"
  },
  sortOptions: {
    title: "Sortieren nach"
  },
  sharing: {
    title: "Teilen",
    share: "Teilen",
    accessLevel: "Zugriffsstufe",
    accessCode: "Zugangscode",
    readOnly: "Nur Lesen",
    edit: "Bearbeiten",
    copy: "Link kopieren",
    copied: "Link kopiert!",
    emailPlaceholder: "beispiel@email.com",
    namePlaceholder: "Empfänger Name",
    messagePlaceholder: "Persönliche Nachricht hinzufügen...",
    recipientEmail: "Empfänger E-Mail",
    recipientName: "Empfänger Name",
    message: "Nachricht",
    defaultMessage: "Ich lade dich ein, an meiner Hochzeit mitzuwirken!",
    invitationCreated: "Einladung erfolgreich erstellt",
    success: "Erfolgreich geteilt"
  },
  upgrade: "Aktualisieren",
  content: "Inhalt",
  today: "Heute",
  yesterday: "Gestern",
  saving: "Speichern...",
  viewAll: "Alles ansehen",
  currentEvent: "Aktuelles Ereignis"
};
